export function requestPassword(formName, clientId, email) {
    return (dispatch) => Promise.resolve(
            dispatch({
                type: 'REQUEST_PASSWORD_SUBMIT',
                formName,
                clientId,
                email,
            })
        );
}

export function requestPasswordFormReset(formName, resetForm) {
    return (dispatch) => Promise.resolve(
            dispatch({
                formName,
                resetForm,
                type: 'REQUEST_PASSWORD_FORM_RESET',
            })
        );
}
